import React from 'react';

const MmcCard = ({ children, className = '', ...props }) => {
    return (
        <div className={`mmc-card ${className}`} {...props}>
            {children}
        </div>
    );
};

export default MmcCard;
